export default __webpack_public_path__ + "static/media/8615.e505fe80.png";